import React from 'react';
import { Layout, LayoutSidebarSettings } from '@benzinga/core-ui';
import { WordpressPost } from '@benzinga/content-manager';
import { MoneySidebar } from './MoneySidebar';
import { MoneyLeftSidebar, showLeftSidebar } from './MoneyLeftSidebar';
import { MoneyBlocksLayout } from './MoneyBlocksLayout';
import { MoneyPost } from './MoneyPost';
import classNames from 'classnames';
import styles from './MoneyPostLayout.module.css';

interface MoneyPostLayout {
  layoutAboveArticle?: React.ReactElement | null;
  layoutAboveSidebar?: React.ReactElement | null;
  layoutBelowArticle?: React.ReactElement | null;
  layoutSidebar?: React.ReactElement | boolean;
  layoutMainClassName?: string;
  maxWidth?: string;
  post: WordpressPost | null;
  sidebarSettings?: LayoutSidebarSettings;
  wrapperClassName?: string;
}

export const MoneyPostLayout: React.FC<MoneyPostLayout> = ({
  layoutAboveArticle,
  layoutAboveSidebar,
  layoutBelowArticle,
  layoutMainClassName,
  layoutSidebar,
  maxWidth = '1100px',
  post,
  sidebarSettings,
  wrapperClassName,
}) => {
  return (
    <div className={classNames(styles.wrapper, wrapperClassName)}>
      <Layout
        layoutFooter={post?.footer && <MoneyBlocksLayout post={post.footer} />}
        layoutHeader={post?.header && <MoneyBlocksLayout post={post.header} />}
        layoutHeaderOptions={post?.header?.options}
        layoutLeftSidebar={post && showLeftSidebar(post) ? <MoneyLeftSidebar post={post} /> : false}
        layoutMain={
          <main className={classNames('money-page-main', { [`${layoutMainClassName}`]: !!layoutMainClassName })}>
            <MoneyBlocksLayout post={post?.content_header} />
            <MoneyPost post={post ?? null} showTitle={false}>
              {layoutAboveArticle}
            </MoneyPost>
            {layoutBelowArticle}
            <MoneyBlocksLayout post={post?.content_footer} />
          </main>
        }
        layoutSidebar={
          (post?.sidebar || layoutAboveSidebar) && Number(post?.sidebar?.blocks?.length) > 0 ? (
            <>
              {layoutAboveSidebar}
              {post?.sidebar && <MoneySidebar post={post} sidebar={post.sidebar} />}
            </>
          ) : (
            layoutSidebar
          )
        }
        maxWidth={maxWidth}
        sidebarSettings={{
          ...sidebarSettings,
          visibleOnMobile: true,
        }}
        title={''}
      />
    </div>
  );
};

export default MoneyPostLayout;
